import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionSubTitle, Typography, SecondarySection } from 'common/components';
import { CeilingsMoreInfo } from '../ceilings-more-info';
import { LIGHTING_TYPE_LIST } from './ceilings-lighting-type-section-constants';
import {
  ceilingsLightingTypeText,
  ceilingsLightingTypeTitle,
} from './ceilings-lighting-type-section-styles';

type CeilingsLightingTypeSectionProps = {
  onConsultationSignupBtnClick: () => void;
};

export const CeilingsLightingTypeSection = ({
  onConsultationSignupBtnClick,
}: CeilingsLightingTypeSectionProps) => {
  const { t } = useTranslation();

  return (
    <SecondarySection>
      <SectionSubTitle className={ceilingsLightingTypeTitle} margin="s">
        {t('lighting-type-section.title')}
      </SectionSubTitle>
      <Typography className={ceilingsLightingTypeText} variant="l" size="body_long">
        {t('lighting-type-section.subtitle')}
      </Typography>

      <CeilingsMoreInfo
        cardList={LIGHTING_TYPE_LIST}
        cardPerRow={2}
        onConsultationSignupBtnClick={onConsultationSignupBtnClick}
      />
    </SecondarySection>
  );
}
